var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    display: "block",
    role: "presentation",
    viewBox: "0 0 101 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 15.222 0 C 15.227 1.941 16.208 3.748 17.844 4.809 C 18.778 5.421 19.865 5.74 20.975 5.74 L 20.975 9.867 C 18.913 9.867 16.898 9.22 15.222 8.02 L 15.222 16.406 C 15.222 20.602 11.816 24 7.611 24 C 3.406 24 0 20.602 0 16.406 C 0 12.222 3.418 8.813 7.611 8.813 C 7.956 8.818 8.3 8.841 8.639 8.888 L 8.639 13.102 C 8.306 12.991 7.962 12.938 7.611 12.938 C 5.742 12.938 4.206 14.408 4.136 16.273 C 4.066 18.184 5.561 19.804 7.477 19.874 C 9.392 19.944 11.004 18.452 11.08 16.54 L 11.086 0 Z",
    fill: "rgb(7, 16, 12)",
    height: "24px",
    id: "d9kdV264J",
    width: "20.9746px"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 11.84 3.719 L 8.452 3.719 L 8.452 17.484 L 4.24 17.484 L 4.24 3.719 L 0 3.725 L 0 0 L 13.037 0 Z",
    fill: "rgb(7, 16, 12)",
    height: "17.48433px",
    id: "emTrT8_1_",
    transform: "translate(24.929 5.764)",
    width: "13.037100000000002px"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.177 11.924 L 0.023 11.924 L 0 0 L 4.177 0 Z",
    fill: "rgb(7, 16, 12)",
    height: "11.923800000000002px",
    id: "ME7F9Enlo",
    transform: "translate(38.766 11.324)",
    width: "4.1768px"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.177 8.142 L 8.317 4.091 L 13.3 4.091 L 8.066 9.161 L 13.931 17.536 L 9.328 17.536 L 5.415 11.726 L 4.177 12.926 L 4.177 17.53 L 0 17.53 L 0 0 L 4.177 0 Z",
    fill: "rgb(7, 16, 12)",
    height: "17.53609px",
    id: "v5LHfzDmA",
    transform: "translate(44.601 5.712)",
    width: "13.930599999999998px"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 12.143 3.719 L 8.464 3.719 L 8.464 17.484 L 4.24 17.484 L 4.24 3.719 L 0 3.725 L 0 0 L 13.341 0 Z",
    fill: "rgb(7, 16, 12)",
    height: "17.48433px",
    id: "Y82srG4fw",
    transform: "translate(59.331 5.764)",
    width: "13.340799999999994px"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.17 8.142 L 8.312 4.091 L 13.3 4.091 L 8.066 9.161 L 13.931 17.536 L 9.328 17.536 L 5.414 11.726 L 4.176 12.926 L 4.176 17.53 L 0 17.53 L 0 0 L 4.17 0 Z",
    fill: "rgb(7, 16, 12)",
    height: "17.53609px",
    id: "cycJToeCz",
    transform: "translate(87.075 5.712)",
    width: "13.930800000000005px"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 7.155 0 C 11.109 0.006 14.31 3.199 14.305 7.139 C 14.305 11.078 11.098 14.272 7.149 14.272 C 3.201 14.272 0 11.073 0 7.133 C 0 3.193 3.207 0 7.155 0 Z M 7.155 3.672 C 5.234 3.672 3.68 5.221 3.68 7.139 C 3.68 9.056 5.234 10.606 7.155 10.606 C 9.077 10.606 10.637 9.056 10.631 7.139 C 10.631 5.221 9.077 3.672 7.155 3.672 Z",
    fill: "rgb(7, 16, 12)",
    height: "14.27247px",
    id: "z2VcUhsGK",
    transform: "translate(71.06 8.97)",
    width: "14.304707336506167px"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 2.104 0 C 3.265 0 4.206 0.94 4.206 2.099 C 4.206 3.257 3.265 4.196 2.104 4.196 C 0.942 4.196 0 3.257 0 2.099 C 0 0.94 0.942 0 2.104 0 Z",
    fill: "rgb(7, 16, 12)",
    height: "4.19629px",
    id: "BxAXzHHFb",
    transform: "translate(38.748 5.764)",
    width: "4.206099999999999px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.f4ea50d6db895407566db5c91d613f87.svg";
export { ForwardRef as ReactComponent };